export const formatSavedValue = (value) => {
  const reducer = (combined, [key, values]) => {
    if (key.length > 0) {
      values.forEach((value) => {
        if (!combined[key]?.includes(value) && value.length > 0) {
          combined[key] = [...(combined[key] ?? []), value];
        }
      });
    }
    return combined;
  };

  return {
    ...value,
    componentOnStateVisibility: Object.fromEntries(
      Object.entries(value.componentOnStateVisibility || {}).map(
        ([key, oldDict]) => {
          const newDict = {
            showOnState: oldDict.showOnState?.reduce(reducer, {}),
            hideOnState: oldDict.hideOnState?.reduce(reducer, {}),
          };
          return [key, newDict];
        }
      )
    ),
  };
};

export const removeVisibilityRoleExceptionFunc = (component, role) => (
  oldUserConfig
) => {
  const roleList =
    oldUserConfig?.componentVisibilityRoleExceptions?.[component] ?? [];
  if (!roleList.includes(role)) return oldUserConfig;
  if (roleList.length === 1) {
    return clearVisibilityExceptionRoleFunc(component)(oldUserConfig);
  }
  return {
    ...oldUserConfig,
    componentVisibilityRoleExceptions: {
      ...oldUserConfig.componentVisibilityRoleExceptions,
      [component]: roleList.filter((r) => r !== role),
    },
  };
};

export const addVisibilityRoleExceptionFunc = (component, role) => (
  oldUserConfig
) => {
  const roleList =
    oldUserConfig?.componentVisibilityRoleExceptions?.[component] ?? [];
  if (roleList.includes(role)) return oldUserConfig;
  return {
    ...oldUserConfig,
    componentVisibilityRoleExceptions: {
      ...oldUserConfig.componentVisibilityRoleExceptions,
      [component]: [...roleList, role],
    },
  };
};

export const clearVisibilityExceptionRoleFunc = (component) => (
  oldUserConfig
) => {
  const roleList = oldUserConfig?.componentVisibilityRoleExceptions ?? [];
  if (!roleList[component]) return oldUserConfig;
  return {
    ...oldUserConfig,
    componentVisibilityRoleExceptions: Object.fromEntries(
      Object.entries(roleList).filter(([comp, _roles]) => comp !== component)
    ),
  };
};

export const deleteComponentVisibilityFunc = (component) => (oldUserConfig) => {
  const componentVisibility = {
    ...oldUserConfig?.componentVisibility,
  };
  if (component in componentVisibility) {
    delete componentVisibility[component];
    return {
      ...oldUserConfig,
      componentVisibility,
    };
  }
  return oldUserConfig;
};

export const setComponentVisibilityFunc = (component, visibility) => (
  oldUserConfig
) => {
  const compVis = oldUserConfig?.componentVisibility || [];
  if (compVis[component] === visibility) return oldUserConfig;
  return {
    ...oldUserConfig,
    componentVisibility: {
      ...compVis,
      [component]: visibility,
    },
  };
};

export const addVisibilityUserAccessFunc = (component, userId) => (
  oldUserConfig
) => {
  const list = oldUserConfig?.componentVisibilityUserAccess?.[component] ?? [];
  if (list.includes(userId)) return oldUserConfig;
  return {
    ...oldUserConfig,
    componentVisibilityUserAccess: {
      ...oldUserConfig.componentVisibilityUserAccess,
      [component]: [...list, userId],
    },
  };
};

export const removeVisibilityUserAccessFunc = (component, userId) => (
  oldUserConfig
) => {
  const list = oldUserConfig?.componentVisibilityUserAccess?.[component] ?? [];
  if (!list.includes(userId)) return oldUserConfig;
  return {
    ...oldUserConfig,
    componentVisibilityUserAccess: {
      ...oldUserConfig.componentVisibilityUserAccess,
      [component]: list.filter((id) => id !== userId),
    },
  };
};

export const clearVisibilityUserAccessFunc = (component) => (oldUserConfig) => {
  const access = oldUserConfig?.componentVisibilityUserAccess ?? {};
  if (!access[component]) return oldUserConfig;
  return {
    ...oldUserConfig,
    componentVisibilityUserAccess: Object.fromEntries(
      Object.entries(access).filter(([comp]) => comp !== component)
    ),
  };
};

export const formatLoadedUserConfigValue = (value) => {
  return value == null || value?.componentOnStateVisibility == null
    ? value
    : {
        ...value,
        componentOnStateVisibility: Object.fromEntries(
          Object.entries(value.componentOnStateVisibility).map(
            ([key, oldDict]) => {
              const newDict = {
                showOnState:
                  oldDict.showOnState && Object.entries(oldDict?.showOnState),
                hideOnState:
                  oldDict.hideOnState && Object.entries(oldDict?.hideOnState),
              };
              return [key, newDict];
            }
          )
        ),
      };
};
